import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import admin from "./modules/admin";
import course from "./modules/course";
import home from "./modules/home";
import login from "./modules/login";
import register from "./modules/register";
import sessionDetails from "./modules/sessionDetails";
import session from "./modules/session";
import sessionlive from "./modules/sessionlive";
import profile from "./modules/profile";
import earnings from "./modules/earnings";
import message from "./modules/message";
import notifications from "./modules/notifications";

export default new Vuex.Store({
    modules: {
        admin,
        course,
        earnings,
        home,
        login,
        message,
        notifications,
        profile,
        register,
        sessionDetails,
        session,
        sessionlive,
    },
})